var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasErrors)?_c('div',_vm._l((_vm.errors),function(error,index){return _c('v-alert',{key:index,attrs:{"color":"error","dark":"","dense":""}},[_vm._v("\n    "+_vm._s(error)+"\n  ")])}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }